module.exports = __webpack_public_path__ + "img/support.fc376adf.jpg";